// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M12 2C17.52 2 22 6.48 22 12S17.52 22 12 22 2 17.52 2 12 6.48 2 12 2M16.24 7.76A1 1 0 0 0 14.82 7.76L7.75 14.83A1 1 0 1 0 9.16 16.24L16.23 9.17A1 1 0 0 0 16.23 7.76"/>';

/** Block (status). */
const icon: IconData = {
  id: "block",
  name: "Block",
  category: "status",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: m0 },
    outline: {
      svg: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8.46 15.54L15.53 8.47M21 12A9 9 0 1 1 3 12 9 9 0 0 1 21 12Z"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M11.9 2L14.11 2.23 15.98 2.83 17.67 3.77 19.14 5 20.34 6.49 21.25 8.2 21.81 10.09 22 12.1 21.77 14.11 21.17 15.98 20.23 17.67 19 19.14 17.51 20.34 15.8 21.25 13.91 21.81 11.9 22 9.89 21.77 8.02 21.17 6.33 20.23 4.87 19 3.66 17.51 2.75 15.8 2.19 13.91 2 11.9 2.23 9.89 2.83 8.02 3.77 6.33 5 4.87 6.49 3.66 8.2 2.75 10.09 2.19Z"/></g><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8.46 15.54L15.53 8.47M21 12A9 9 0 1 1 3 12 9 9 0 0 1 21 12Z"/>',
    },
  },
  animation: () => import("../animations/block.js"),
};

export default icon;
